<template>
  <div>
    <div v-if="error != ''" class="p-4">
      <wrapper-mobile-view>
        <div class="w-100 py-3 px-4">
          <div class="w-100">
            <div class="row">
              <div class="col-1 align-self-center" @click="pageTo('account')">
                <div class="d-inline-grid cursor-pointer">
                  <img src="../../../assets/img/icon/back.png" class="mt-1" width="20">
                </div>
              </div>
              <div class="col-9 align-self-center">
                <p class="mb-0 body-1-2">{{$t('hotel.concierge.membership')}}</p>
              </div>
            </div>
          </div>
        </div>
      </wrapper-mobile-view>
      <block :height="45" />
      <ErrorMessage :message="error" />
    </div>
    <div v-else class="w-100">
      <div class="position-relative bg-grey-gradient" style="height: 260px;">
        <div class="w-100 py-3 px-4">
          <div class="w-100">
            <div class="row">
              <div class="col-1 align-self-center" @click="pageTo('account')">
                <div class="d-inline-grid cursor-pointer">
                  <svg width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18 7.875H4.30875L10.5975 1.58625L9 0L0 9L9 18L10.5862 16.4138L4.30875 10.125H18V7.875Z" fill="#222"/>
                  </svg>
                </div>
              </div>
              <div class="col-9 align-self-center">
                <p class="mb-0 body-1-2">{{$t('hotel.concierge.membership')}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-4 text-center">
          <div v-if="is_load">
            <b-skeleton class="mx-auto mb-3" width="20%" height="50px"></b-skeleton>
            <b-skeleton class="mx-auto mb-3" width="30%" height="22px"></b-skeleton>
            <div class="w-100 no-ws">
              <b-skeleton class="d-inline-block align-middle mx-1" width="30%" height="47px"></b-skeleton>
              <b-skeleton class="d-inline-block align-middle mx-1" width="30%" height="47px"></b-skeleton>
            </div>
          </div>
          <template v-else>
            <div class="d-table mx-auto position-relative">
              <p class="mb-0 font-lato ls-1-5 d-inline-block align-middle" style="font-size: 50px;">{{data.card.membership_user.point}}</p>
              <span class="mb-0 position-absolute body-1-4" style="bottom: 13px; right: -55px;">Points</span>
            </div>
            <p class="body-1-4 mb-3 text-green">{{data.card.name}} Member</p>
            <div class="w-100 no-ws">
              <div @click="pageTo('member/detail')" class="d-inline-block align-middle px-3 radius-6 mx-1 border-semi-grey bg-white no-ws cursor-pointer" style="padding-block: 12px;">
                <img class="d-inline-block align-middle mr-2" src="../../../assets/img/icon/crown.png" height="20" />
                <p class="mb-0 body-2-1 d-inline-block align-middle">Membership Detail</p>
              </div>
              <div @click="pageTo('member/point-history')" class="d-inline-block align-middle px-3 radius-6 mx-1 border-semi-grey bg-white no-ws cursor-pointer" style="padding-block: 12px;">
                <img class="d-inline-block align-middle mr-2" src="../../../assets/img/icon/coin.png" height="20" />
                <p class="mb-0 body-2-1 d-inline-block align-middle">Point History</p>
              </div>
            </div>
          </template>
        </div>
      </div>
      <!-- <div class="w-100">
        <b-form-checkbox v-model="checked" name="check-button" switch inline size="lg">  
        </b-form-checkbox>
      </div> -->
      <!-- REWARD -->
      <Reward :membership_user_code="data.card.membership_user.uniq_code"></Reward>
    </div>
  </div>
</template>

<script>
  import {get} from '@/services/index.js'
  import {mapGetters,mapMutations} from "vuex";
  import MemberCard from '@/components/hotel/concierge/member/MemberCard'
  import Reward from './Reward';

  export default {
    components:{
      MemberCard,
      Reward
    },
    data() {
      return {
        is_load: true,
				error: '',
				data:{
					card: {}
				},
        checked: false
      }
    },
    computed:{
      ...mapGetters(['getMerchant','isNotLogin','getCurrentUser']),
    },
    mounted(){
      this.loadData()
    },
    methods:{
      ...mapMutations(['setMembershipRewardApplied']),
      // SETUP DATA
      loadData(){
        this.is_load = true
        this.error = ''
        Promise.all([
          this.loadMemberCard()
        ])
        .catch(err=>this.error=err)
        .finally(()=>{
          setTimeout(()=>{
            this.is_load = false
          },400)
        })
      },
      loadMemberCard(){
        return new Promise((success,fail)=>{
          get("CONCIERGE","membership/user-member-card-detail",{
	          merchant_id: this.getMerchant.id
	        }).then(response=>{
	        	let res = response.data
	         	if(res.success){
              this.data.card = res.data
	         		success()
	         	}else{
	         		fail(res.message)
	         	}
	        })
        })
      },

      // GENERAL
      pageTo(page){
        this.$router.push(`/${this.getMerchant.code}/${page}`)
      }
    }
  }
</script>
<style scoped>
.bg-grey-gradient{
  background: rgb(235,235,235);
  background: linear-gradient(0deg, rgba(235,235,235,1) 0%, rgba(255,255,255,1) 100%);
}
</style>


// WEBPACK FOOTER //
// src/pages/general/membership/index.vue